module.exports = __webpack_public_path__ + "h5/img/master_4.d71efc56.jpg";